<header id="header" class="" [ngClass]="{'header-fixed': windowScrolled }">
  <div class="container header-content">

    <div id="logo" class="header-logo">
      <a (click)="scrollToElement('hero')"><img class="logo" src="../../../assets/img/logo-white.png"
          alt="Vidal Dev Consultoria"></a>
    </div>

    <button (click)="onClick()" type="button" id="mobile-nav-toggle"><i class="fa fa-bars"></i></button>
    <nav id="nav-menu-container">
      <ul class="nav-menu">
        <li class=""><a (click)="scrollToElement('hero')">Home</a></li>
        <li><a (click)="scrollToElement('about')">Sobre</a></li>
        <li><a (click)="scrollToElement('facts')">Tecnologias</a></li>
        <li><a (click)="scrollToElement('services')">Serviços</a></li>
        <li><a (click)="scrollToElement('portfolio')">Portfolio</a></li>
        <!-- <li><a (click)="scrollToElement('team')">Equipe</a></li> -->
        <li><a (click)="scrollToElement('contact')">Contato</a></li>
      </ul>
    </nav>

    <div *ngIf="modal" class="mobile-body-overly">
      <nav id="mobile-nav">
        <ul>
          <li class="menu-active">
            <a (click)="onClick();scrollToElement('hero')">Home</a>
          </li>
          <li><a (click)="onClick();scrollToElement('about')">Sobre</a></li>
          <li><a (click)="onClick();scrollToElement('facts')">Tecnologias</a></li>
          <li><a (click)="onClick();scrollToElement('services')">Serviços</a></li>
          <li><a (click)="onClick();scrollToElement('portfolio')">Portfolio</a></li>
          <!-- <li><a (click)="onClick();scrollToElement('team')">Equipe</a></li> -->

          <li><a (click)="onClick();scrollToElement('contact')">Contato</a></li>
        </ul>
      </nav>
    </div>
  </div>
</header>

<section id="hero">

  <div id="tsparticles"></div>
  <div class="hero-container">
    <img class="logo-center" src="../../../assets/img/logo-white.png" alt="Vidal Dev Consultoria">
    <h2>
      <strong>
        <i>Transformando desafios em soluções digitais</i>
      </strong>
    </h2>
    <a (click)="scrollToElement('about')" class="btn-get-started">Saiba mais</a>
  </div>
</section>

<main id="main">

  <section id="about">
    <div class="container">
      <div class="row about-container">

        <div class="col-lg-6 content order-lg-1 order-2">
          <h2 class="title">Sobre a Vidal Dev Consultoria</h2>
          <p>
            Fundada em 2021 por Ivan Vidal, a Vidal Dev Consultoria é uma empresa de tecnologia com foco em soluções
            digitais sob medida para web e dispositivos móveis. Atuamos com excelência no desenvolvimento de sistemas,
            sempre alinhados às necessidades dos nossos clientes e às mais modernas práticas de engenharia de software.

            Com uma abordagem centrada em resultados, buscamos entregar aplicações robustas, escaláveis e com alto
            padrão de qualidade, proporcionando experiências digitais eficientes e intuitivas. Acreditamos no poder da
            tecnologia como ferramenta de transformação e inovação para empresas e pessoas.
          </p>

          <div class="icon-mission">Missão:</div>
          <p>Conectar ideias à inovação por meio da tecnologia, promovendo soluções inteligentes que gerem valor real
            aos nossos clientes.</p>
          <h2 class="title">Diferenciais</h2>

          <div class="icon-box wow fadeInUp">
            <div class="icon"><i class="fa fa-photo"></i></div>
            <h4 class="title"><a href="#">Fidelidade de Interfaces</a></h4>
            <p class="description">Realizamos construção de cada projeto pensando na melhor experiência do usuário,
              seguindo fielmente os protótipos.</p>
          </div>

          <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
            <div class="icon"><i class="fas fa-laptop-code"></i></div>
            <h4 class="title"><a href="">Clean Code</a></h4>
            <p class="description">No desenvolvimento de projetos presamos pela qualidade do código, usando as melhores
              práticas do mercado </p>
          </div>

          <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
            <div class="icon"><i class="fa fa-bar-chart"></i></div>
            <h4 class="title"><a href="">Metodologias Ágeis</a></h4>
            <p class="description">Utilizamos metodologias de desenvolvimento onde temos, encontros para colher
              feedbacks e alinhamentos para agilizar o processo de construção do projeto.</p>
          </div>

        </div>

        <div class="col-lg-6 background order-lg-2 order-1 wow fadeInRight"></div>
      </div>

    </div>
  </section>

  <section id="facts">
    <div class="container wow fadeIn">
      <div class="section-header">
        <h3 class="section-title">Tecnologias</h3>
        <p class="section-description">Utilizamos tecnologias modernas e práticas para criação de nossos projetos.</p>
      </div>
      <div class="tech__content">
        <div class="tech__content-grid">
          <div class="tech__item">
            <span><i id="Angular" class="size fab fa-angular"></i></span>
            <p class="text">Angular</p>
          </div>
          <div class="tech__item">
            <span><img class="tech__img" src="assets/icons/typescript.svg" alt="TypeScript"></span>
            <p class="text">TypeScript</p>
          </div>
          <div class="tech__item">
            <span><i id="Js" class="size fab fa-js-square"></i></span>
            <p class="text">JavaScript</p>
          </div>
          <div class="tech__item">
            <span><i id="Rjs" class="size fab fa-react"></i></span>
            <p class="text">React JS</p>
          </div>
          <div class="tech__item">
            <span><i id="Njs" class="size fab fa-node-js"></i></span>
            <p class="text">Node JS</p>
          </div>
          <div class="tech__item">
            <span><i id="Rn" class="size fab fa-react"></i></span>
            <p class="text">React Native</p>
          </div>
          <div class="tech__item">
            <span><i id="Boot" class="size fab fa-bootstrap"></i></span>
            <p class="text">Bootstrap</p>
          </div>
          <div class="tech__item">
            <span><i id="Material" class="size fab fa-angular"></i></span>
            <p class="text">Angular Material</p>
          </div>
          <div class="tech__item">
            <span><img class="tech__img" src="assets/icons/icon-ionic.svg" alt="Ionic"></span>
            <p class="text">Ionic</p>
          </div>
          <div class="tech__item">
            <span><i id="Git" class="size fab fa-git-alt"></i></span>
            <p class="text">Git</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="services">
    <div class="container wow fadeIn">
      <div class="section-header">
        <h3 class="section-title w">Serviços</h3>
        <p class="section-description">Os nossos serviços estão distribuidos nas categorias abaixo.</p>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.4s">
          <div class="box">
            <div class="icon"><span href=""><i class="fas fa-laptop"></i></span></div>
            <h4 class="title"><span href="">Desenvolvimento web</span></h4>
            <p class="description">Atuamos no desenvolvimento de sistemas utilizados diretamente na web </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
          <div class="box">
            <div class="icon"><span href=""><i class="fas fa-mobile-alt"></i></span></div>
            <h4 class="title"><span href="">Desenvolvimento de App</span></h4>
            <p class="description">Construimos aplicativos para a maior variedade de negócios.</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.4s">
          <div class="box">
            <div class="icon"><span href=""><i class="fa fa-desktop"></i></span></div>
            <h4 class="title"><span href="">Prototipação</span></h4>
            <p class="description">Utilizamos as melhores práticas do mercado para desenvolver protótipos visando a
              melhor experiência do usuário.</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
          <div class="box">
            <div class="icon"><span href=""><i class="fas fa-chart-line"></i></span></div>
            <h4 class="title"><span href="">Dashboards</span></h4>
            <p class="description">Desenvolvimento de sistemas interno acessados pela internet, para melhor controle de
              seu negócio, sem necessidade de hardwares poderosos.</p>
          </div>
        </div>
      </div>

    </div>
  </section>

  <section id="call-to-action">
    <div class="container wow fadeIn">
      <div class="row">
        <div class="col-lg-9  text-right text-lg-left">
          <p class="cta-text">
            <i class="fas fa-quote-left"></i> A transformação digital começa com uma boa ideia — e se concretiza com
            código, estratégia <br> e excelência.<i class="fas fa-quote-right"></i>
          </p>

          <small class="autor">Vidal Dev Consultoria</small>
        </div>
        <div class="col-lg-3 cta-btn-container text-center">
          <a class="cta-btn align-middle" (click)="scrollToElement('contact')">Fale conosco</a>
        </div>
      </div>

    </div>
  </section>

  <section id="portfolio">
    <div class="container wow fadeInUp">
      <div class="section-header">
        <h3 class="section-title">Portfolio</h3>
        <p class="section-description">Os nossos projetos criados até o momento, estão divididos por categorias</p>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <ul id="portfolio-flters">
            <li *ngFor="let cat of categories" [class.filter-active]="selectedCategory === cat.value"
              (click)="filterPortfolio(cat.value)">
              {{ cat.label }}
            </li>
          </ul>
        </div>
      </div>
      <div class="row" id="portfolio-wrapper">
        <div *ngFor="let item of portfolioItems" class="col-lg-3 col-md-6 portfolio-item" [ngClass]="item.category"
          [class.hide]="!shouldShow(item.category)">
          <a [href]="item.link" [target]="item.external ? '_blank' : '_self'">
            <img [src]="item.image" [alt]="item.title">
            <div class="details">
              <h4>{{ item.title }}</h4>
              <span>{{ item.description }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- <section id="team">
    <div class="container wow fadeInUp">
      <div class="section-header">
        <h3 class="section-title w">Equipe</h3>
        <p class="section-description">Aqui você pode ver os colaboradores de nossa empresa</p>
      </div>
      <div class="row" style="justify-content: center;">
        <div class="col-lg-3 col-md-6">
          <div class="member">
            <div class="pic"><img src="../../assets/img/perfil.jpeg" alt=""></div>
            <h4>Ivan Vidal</h4>
            <span>FullStack Developer</span>
            <div class="social">
              <a href="https://github.com/Vidal-Dev-Consultoria" target="_blank" class="github"><i
                  class="fa fa-github"></i></a>
              <a href="https://www.instagram.com/vidaldevconsultoria/" target="_blank" class="instagram"><i
                  class="fa fa-instagram"></i></a>
              <a href="https://mail.google.com/mail/u/0/?tab=wm&ogbl#inbox?compose=CllgCJlJVtNjwXXkXJcSwlWlHKlFjCcsKHPhbwJFCzbqTfLnchWHTJtrqXVTmHDWjKRPhdZCztL"
                target="_blank" class="google-plus"><i class="fab fa-google-plus-g"></i></a>
              <a target="_blank" href="https://www.linkedin.com/company/vidal-dev-consultoria" class="linkedin"><i
                  class="fa fa-linkedin"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <section id="contact">
    <div class="container wow fadeInUp">
      <div class="section-header">
        <h3 class="section-title">Contato</h3>
        <p class="section-description f">Se interessou pelos nossos serviços ou tem alguma dúvida? Envie sua mensagem
          abaixo!</p>
      </div>
    </div>
    <div class="container wow fadeInUp mt-5">
      <div class="row contacts">
        <div class="col-lg-3 col-md-4 info-contacts">
          <div class="info-center">
            <div class="info">
              <div>
                <i class="fa fa-map-marker"></i>
                <p>São Paulo - SP</p>
              </div>
              <div>
                <i class="fa fa-envelope"></i>
                <p>ivanvidal.dev&#64;gmail.com</p>
              </div>
              <div>
                <i class="fa fa-phone"></i>
                <p>+55 (11) 9 6834-4811</p>
              </div>
            </div>
          </div>
          <div class="social-links">
            <h1 class="rede">Rede sociais</h1>
            <a href="https://api.whatsapp.com/send?L=pt_BR&phone=5511968344811&text=Tenho interesse em seus serviços."
              target="_blank" class="whatsapp"><i class="fa fa-whatsapp"></i></a>
            <a href="https://github.com/Vidal-Dev-Consultoria" target="_blank" class="github"><i
                class="fa fa-github"></i></a>
            <a href="https://www.instagram.com/vidaldevconsultoria/" target="_blank" class="instagram"><i
                class="fa fa-instagram"></i></a>
            <a href="https://mail.google.com/mail/u/0/?tab=wm&ogbl#inbox?compose=CllgCJlJVtNjwXXkXJcSwlWlHKlFjCcsKHPhbwJFCzbqTfLnchWHTJtrqXVTmHDWjKRPhdZCztL"
              target="_blank" class="google-plus"><i class="fab fa-google-plus-g"></i></a>
            <a target="_blank" href="https://www.linkedin.com/company/vidal-dev-consultoria" class="linkedin"><i
                class="fa fa-linkedin"></i></a>
          </div>
        </div>


        <div class="col-lg-5 col-md-8">
          <div class="form">
            <div *ngIf="send" class="sendmessage">Sua mensagem foi enviada com sucesso!</div>
            <div *ngIf="err" class="errormessage"> Mensagem não enviada!
              Preencha todo o Formulário </div>
            <form [formGroup]="contactForm" (ngSubmit)="sendEmail()">
              <div>
                <input id="name" type="text" class="form-control" formControlName="name" placeholder="Nome" required
                  minlength="3" maxlength="100" [ngClass]="{
                                'is-invalid': contactForm.get('name')?.invalid && contactForm.get('name')?.touched
                            }" />
                <div *ngIf="contactForm.get('name')?.invalid && contactForm.get('name')?.touched" class="form-error">
                  <small *ngIf="contactForm.get('name')?.errors?.['required']">Nome é obrigatório.</small>
                  <small *ngIf="contactForm.get('name')?.errors?.['minlength']">
                    Nome deve ter pelo menos 3 caracteres.
                  </small>
                </div>
              </div>
              <div>
                <input id="email" type="email" class="form-control" formControlName="email" placeholder="Email" required
                  [ngClass]="{
                                'is-invalid': contactForm.get('email')?.invalid && contactForm.get('email')?.touched
                            }" />
                <div *ngIf="contactForm.get('email')?.invalid && contactForm.get('email')?.touched" class="form-error">
                  <small *ngIf="contactForm.get('email')?.errors?.['required']">Email é obrigatório.</small>
                  <small *ngIf="contactForm.get('email')?.errors?.['email']">Email inválido.</small>
                </div>
              </div>

              <div>
                <input id="subject" type="text" class="form-control" formControlName="subject" placeholder="Assunto"
                  required minlength="3" maxlength="100" [ngClass]="{
                                'is-invalid': contactForm.get('subject')?.invalid && contactForm.get('subject')?.touched
                            }" />
                <div *ngIf="contactForm.get('subject')?.invalid && contactForm.get('subject')?.touched"
                  class="form-error">
                  <small *ngIf="contactForm.get('subject')?.errors?.['required']">Assunto é
                    obrigatório.</small>
                  <small *ngIf="contactForm.get('subject')?.errors?.['minlength']">
                    Assunto deve ter pelo menos 3 caracteres.
                  </small>
                </div>
              </div>

              <div>
                <textarea id="message" class="form-control" formControlName="message" rows="5" placeholder="Mensagem"
                  required minlength="10" [ngClass]="{
                                'is-invalid': contactForm.get('message')?.invalid && contactForm.get('message')?.touched
                            }"></textarea>
                <div *ngIf="contactForm.get('message')?.invalid && contactForm.get('message')?.touched"
                  class="form-error">
                  <small *ngIf="contactForm.get('message')?.errors?.['required']">Mensagem é
                    obrigatória.</small>
                  <small *ngIf="contactForm.get('message')?.errors?.['minlength']">
                    Mensagem deve ter pelo menos 5 caracteres.
                  </small>
                </div>
              </div>

              <button type="submit" [disabled]="contactForm.invalid" class="btn-send">
                <span>Enviar</span>
                <i class="fas fa-arrow-right"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<footer id="footer">
  <div class="footer-top">
    <div class="container">
    </div>
  </div>
  <div class="container">
    <div class="copyright">
      &copy; {{ currentYear }} - <strong>Vidal Dev Consultoria </strong>
    </div>
  </div>
</footer>

<a (click)="scrollToElement('hero')" class="back-to-top" [ngClass]="{'block': windowScrolled }"><i class="fas fa-chevron-up"></i></a>

